import { createI18n } from "vue-i18n";

const messages = {
  en: {
    contactUs: "Contact us",
    experienceDunes: "Experience the dunes of The Hague",
    availability: "Availability",
    perNight: "€{price} / night",
    guests: "Guests",
    arrival: "Arrival",
    departure: "Departure",
    adults: "Adults",
    children: "Children",
    babies: "Babies",
    apply: "Apply",
    changeDay: "Change Day",
    everyDay: "Every day",
    finalCleaning: "Final cleaning",
    stay: "Stay",
    nights: "{nights} x € {price},00",
    total: "Total",
    requestBooking: "Request booking",
    viewSeasonalPrices: "View seasonal prices",
    accomodation: "Accommodation",
    reserve: "Reserve",
    contact: "Contact",
    phone: "Phone",
    email: "Email",
    poolHeating: "Pool heating",
    intermediateCleaning: "Intermediate cleaning",
    bookNowTextRoompot: "Bookings are managed via Roompot Netherlands",
    bookNow: "Make a reservation",
    bookNowButton: "Book now",
    bookNowSubtitle: "Enjoy the beach and the Hague dunes",
    emailLabel: "Email:",
    lang: {
      english: "English",
      dutch: "Dutch",
      german: "German",
      italian: "Italian",
      french: "French",
      spanish: "Spanish",
      portuguese: "Portuguese",
    },
    villaFacilities: "Facilities in the villa",
    parkFacilities: "Facilities at the holiday park",
    aboutVillaTitle: "About the Dune Villa at Vakantiepark Kijkduin",
    villaPeek: "A peek inside the Dune Villa",
    features: {
      people: "1 - 7 people",
      bedrooms: "3 bedrooms",
      bathrooms: "2 bathrooms",
      livingSpace: "105m² living space",
      detached: "Detached",
      garden: "Private garden with terrace",
      wifi: "Free wifi",
      fireplace: "Fireplace",
      coffee: "Coffee machine",
      tv: "Television",
      toilet: "Separate toilet",
      sauna: "Sauna",
      beach: "At the beach",
      supermarket: "Supermarket",
      charging: "EV charging point",
      bikes: "Bike and go-kart rental",
      kids: "Kids Club & playgrounds",
      animation: "Animation program",
      swimming: "Indoor pool & toddler pool",
      padel: "Padel & mini golf",
      food: "Café and snack bar",
      wifiPark: "Wifi in park (free)",
    },
    bookingBenefits: {
      freeCancellation: "Free cancellation within 14 days",
      rebookingGuarantee: "Rebooking guarantee within 28 days",
      flexiblePayment: "Flexible payment options",
    },
    aboutVilla: {
      paragraph1:
        "Imagine waking up in this detached dune villa, surrounded by the peaceful nature of Vakantiepark Kijkduin in The Hague. This recently renovated villa accommodates up to seven people and combines modern comfort with a warm, homely atmosphere.",
      paragraph2:
        "Upon entering, you'll find a spacious living room with a cozy seating area and a charming fireplace—perfect for relaxing evenings. The adjoining dining area is ideal for meals and game nights. The modern kitchen is fully equipped with a microwave-oven combo, dishwasher, and coffee machine, allowing you to prepare delicious meals effortlessly.",
      paragraph3:
        "The villa has three comfortable bedrooms. One is located on the ground floor with two single box spring beds—ideal for guests who prefer not to use stairs. Upstairs, there are two more bedrooms: one with two single beds and another with three. With two bathrooms spread over both floors, there's plenty of comfort and privacy. A separate toilet adds extra convenience.",
      paragraph4:
        "For ultimate relaxation, the villa includes a private sauna, perfect after a day of activities. Outside, the furnished terrace invites you to enjoy the fresh sea air and outdoor dining. Free wifi ensures you're always connected to home or your favorite entertainment.",
      paragraph5:
        "Vakantiepark Kijkduin offers a wide range of amenities for all ages—from an indoor pool and sports fields to cozy eateries and a supermarket. The beach, only 500 meters away, makes spontaneous walks or sunny beach days easy to enjoy.",
      paragraph6:
        "Experience the perfect balance of comfort, nature, and relaxation in this beautiful dune villa at Vakantiepark Kijkduin. An unforgettable vacation awaits!",
    },
    footer: {
      contactReserve: "Contact & Reservations",
      slogan:
        "Escape the hustle and unwind in the beautiful dunes of The Hague.",
      tagline: "Your home in the dunes",
      description1:
        "Vakantiehuis Kijkduin, your ideal destination for a relaxing holiday in the beautiful dunes. Located in a serene environment, it's the perfect place to enjoy nature, the beach, and the city. Unwind, explore the surroundings, and create wonderful memories.",
      description2:
        "Do you have questions or would you like to make a reservation? Feel free to contact us!",
      locationTitle: "Location",
      address: {
        line1: "Machiel Vrijenhoeklaan 450-51",
        line2: "2555 NW The Hague",
        country: "Netherlands",
      },
      rights: "All rights reserved",
      designBy: "Design and development by",
      nav: {
        home: "Home",
        reserve: "Reserve",
        privacy: "Privacy",
      },
    },
  },
  nl: {
    contactUs: "Neem contact op",
    experienceDunes: "Beleef de Haagse duinen",
    availability: "Beschikbaarheid",
    perNight: "€{price} / nacht",
    guests: "Gasten",
    persons: "Personen",
    arrival: "Aankomst",
    departure: "Vertrek",
    adults: "Volwassenen",
    children: "Kinderen",
    babies: "Baby's",
    apply: "Toepassen",
    changeDay: "Wisseldag",
    everyDay: "Elke dag",
    finalCleaning: "Eindschoonmaak",
    stay: "Verblijf",
    nights: "{nights} x € {price},00",
    total: "Totaal",
    requestBooking: "Reservering aanvragen",
    viewSeasonalPrices: "Bekijk seizoensgebonden prijzen",
    accomodation: "Accommodatie",
    reserve: "Reserveren",
    contact: "Contact",
    phone: "Telefoon",
    email: "E-mail",
    poolHeating: "Zwembadverwarming",
    intermediateCleaning: "Tussentijdse schoonmaak",
    bookNowTextRoompot:
      "Boekingen gaan via en worden tevens verzorgd door Roompot Nederland",
    bookNow: "Maak een reservering",
    bookNowButton: "Reserveer nu",
    bookNowSubtitle: "Geniet van het strand en de Haagse duinen",
    emailLabel: "E-mail:",
    lang: {
      english: "Engels",
      dutch: "Nederlands",
      german: "Duits",
      italian: "Italiaans",
      french: "Frans",
      spanish: "Spaans",
      portuguese: "Portugees",
    },
    villaFacilities: "Faciliteiten in de villa",
    parkFacilities: "Faciliteiten op het vakantiepark",
    aboutVillaTitle: "Over de Duinvilla op Vakantiepark Kijkduin",
    villaPeek: "Een kijkje in de Duinvilla",
    features: {
      people: "1 - 7 personen",
      bedrooms: "3 slaapkamers",
      bathrooms: "2 badkamers",
      livingSpace: "105m² woonoppervlakte",
      detached: "Vrijstaand",
      garden: "Privétuin met terras",
      wifi: "Gratis wifi",
      fireplace: "Open haard",
      coffee: "Koffieapparaat",
      tv: "Televisie",
      toilet: "Apart toilet",
      sauna: "Sauna",
      beach: "Aan het strand",
      supermarket: "Supermarkt",
      charging: "Oplaadpunt auto",
      bikes: "Fiets- en skelterverhuur",
      kids: "Kids Club & speeltuinen",
      animation: "Animatieprogramma",
      swimming: "Binnenzwembad & peuterbad",
      padel: "Padel & minigolf",
      food: "Eetcafé en snackbar",
      wifiPark: "Wifi op park (gratis)",
    },
    bookingBenefits: {
      freeCancellation: "Gratis annuleren binnen 14 dagen",
      rebookingGuarantee: "Omboekgarantie binnen 28 dagen",
      flexiblePayment: "Flexibel betalen",
    },
    aboutVilla: {
      paragraph1:
        "Stel je voor: ontwaken in deze vrijstaande duinvilla, omringd door de rustgevende natuur van Vakantiepark Kijkduin in Den Haag. Deze recent gerenoveerde villa biedt plaats aan maximaal zeven personen en combineert modern comfort met een warme, huiselijke sfeer.",
      paragraph2:
        "Bij binnenkomst word je verwelkomd in een ruime woonkamer met een gezellige zithoek en een sfeervolle open haard, perfect voor knusse avonden. De aangrenzende eethoek biedt voldoende ruimte voor gezamenlijke maaltijden en spelletjesavonden. De moderne keuken is volledig uitgerust met onder andere een combimagnetron, vaatwasser en koffiepadapparaat, waardoor je moeiteloos heerlijke gerechten kunt bereiden.",
      paragraph3:
        "De villa beschikt over drie comfortabele slaapkamers. Op de begane grond bevindt zich een slaapkamer met twee eenpersoons boxspringbedden, ideaal voor gasten die liever geen trappen lopen. Op de eerste verdieping zijn twee slaapkamers te vinden: één met twee eenpersoons boxspringbedden en een tweede met drie eenpersoons boxspringbedden. Met twee badkamers, verdeeld over beide verdiepingen, is er voldoende privacy en gemak voor alle gasten. Een apart toilet voegt extra comfort toe aan het verblijf.",
      paragraph4:
        "Voor ultieme ontspanning beschikt de villa over een eigen sauna, waar je na een dag vol activiteiten heerlijk kunt relaxen. Buiten nodigt het gemeubileerde terras uit om te genieten van de frisse zeelucht en gezamenlijke maaltijden in de buitenlucht. Gratis wifi zorgt ervoor dat je altijd verbonden blijft met het thuisfront of je favoriete entertainment.",
      paragraph5:
        "Vakantiepark Kijkduin biedt een scala aan faciliteiten voor jong en oud. Van een overdekt zwembad en diverse sportvelden tot gezellige eetgelegenheden en een supermarkt voor de dagelijkse benodigdheden. De nabijheid van het strand, op slechts 500 meter afstand, maakt spontane strandwandelingen en zonnige dagen aan zee binnen handbereik.",
      paragraph6:
        "Ervaar zelf de perfecte balans tussen comfort, natuur en ontspanning in deze prachtige duinvilla op Vakantiepark Kijkduin. Een onvergetelijke vakantie wacht op je!",
    },
    footer: {
      contactReserve: "Contact & Reserveren",
      slogan: "Ontsnap aan de drukte en geniet in de prachtige Haagse duinen.",
      tagline: "Uw thuis in de duinen",
      description1:
        "Vakantiehuis Kijkduin, uw ideale bestemming voor een ontspannen vakantie in de prachtige duinen. Gelegen in een serene omgeving, de perfecte plek om te genieten van de natuur, het strand en de stad. Kom tot rust, verken de omgeving, en maak mooie herinneringen.",
      description2:
        "Heeft u vragen of wilt u reserveren? Neem gerust contact met ons op!",
      locationTitle: "Locatie",
      address: {
        line1: "Machiel Vrijenhoeklaan 450-51",
        line2: "2555 NW Den Haag",
        country: "Nederland",
      },
      rights: "Alle rechten voorbehouden",
      designBy: "Ontwerp en realisatie door",
      nav: {
        home: "Home",
        reserve: "Reserveren",
        privacy: "Privacy",
      },
    },
  },
  de: {
    contactUs: "Kontaktieren Sie uns",
    experienceDunes: "Erleben Sie die Dünen von Den Haag",
    availability: "Verfügbarkeit",
    perNight: "€{price} / Nacht",
    guests: "Gäste",
    arrival: "Anreise",
    departure: "Abreise",
    adults: "Erwachsene",
    children: "Kinder",
    babies: "Babys",
    apply: "Anwenden",
    changeDay: "Wechseltag",
    everyDay: "Jeden Tag",
    finalCleaning: "Endreinigung",
    stay: "Aufenthalt",
    nights: "{nights} x € {price},00",
    total: "Gesamt",
    requestBooking: "Buchung anfragen",
    viewSeasonalPrices: "Saisonpreise anzeigen",
    accomodation: "Unterkunft",
    reserve: "Reservieren",
    contact: "Kontakt",
    phone: "Telefon",
    email: "E-Mail",
    poolHeating: "Poolheizung",
    intermediateCleaning: "Zwischenreinigung",
    bookNowTextRoompot:
      "Buchungen erfolgen über und werden ebenfalls von Roompot Nederland abgewickelt",
    bookNow: "Jetzt buchen",
    bookNowButton: "Jetzt reservieren",
    bookNowSubtitle: "Genießen Sie den Strand und die Dünen von Den Haag",
    emailLabel: "E-Mail:",
    lang: {
      english: "Englisch",
      dutch: "Niederländisch",
      german: "Deutsch",
      italian: "Italienisch",
      french: "Französisch",
      spanish: "Spanisch",
      portuguese: "Portugiesisch",
    },
    villaFacilities: "Ausstattung der Villa",
    parkFacilities: "Einrichtungen im Ferienpark",
    aboutVillaTitle: "Über die Duinvilla im Ferienpark Kijkduin",
    villaPeek: "Ein Blick in die Duinvilla",
    features: {
      people: "1 - 7 Personen",
      bedrooms: "3 Schlafzimmer",
      bathrooms: "2 Badezimmer",
      livingSpace: "105m² Wohnfläche",
      detached: "Freistehend",
      garden: "Privater Garten mit Terrasse",
      wifi: "Kostenloses WLAN",
      fireplace: "Kamin",
      coffee: "Kaffeemaschine",
      tv: "Fernseher",
      toilet: "Separates WC",
      sauna: "Sauna",
      beach: "Am Strand",
      supermarket: "Supermarkt",
      charging: "Ladestation für Auto",
      bikes: "Fahrrad- und Gokartverleih",
      kids: "Kids Club & Spielplätze",
      animation: "Animationsprogramm",
      swimming: "Hallenbad & Kinderbecken",
      padel: "Padel & Minigolf",
      food: "Café und Snackbar",
      wifiPark: "WLAN im Park (gratis)",
    },
    bookingBenefits: {
      freeCancellation: "Kostenlose Stornierung innerhalb von 14 Tagen",
      rebookingGuarantee: "Umbuchungsgarantie innerhalb von 28 Tagen",
      flexiblePayment: "Flexible Zahlungsmöglichkeiten",
    },
    aboutVilla: {
      paragraph1:
        "Stell dir vor, du wachst in dieser freistehenden Duinvilla auf, umgeben von der beruhigenden Natur des Ferienparks Kijkduin in Den Haag. Diese kürzlich renovierte Villa bietet Platz für bis zu sieben Personen und vereint modernen Komfort mit einer gemütlichen, häuslichen Atmosphäre.",
      paragraph2:
        "Beim Betreten empfängt dich ein geräumiges Wohnzimmer mit einer gemütlichen Sitzecke und einem stimmungsvollen Kamin – ideal für kuschelige Abende. Der angrenzende Essbereich bietet ausreichend Platz für gemeinsame Mahlzeiten und Spieleabende. Die moderne Küche ist komplett ausgestattet mit Mikrowellenofen, Geschirrspüler und Kaffeepadmaschine, um mühelos köstliche Gerichte zuzubereiten.",
      paragraph3:
        "Die Villa verfügt über drei komfortable Schlafzimmer. Im Erdgeschoss befindet sich ein Schlafzimmer mit zwei Einzelbetten – ideal für Gäste, die keine Treppen steigen möchten. Im Obergeschoss befinden sich zwei weitere Schlafzimmer: eines mit zwei Einzelbetten und eines mit drei. Mit zwei Badezimmern auf beiden Etagen ist genügend Komfort und Privatsphäre für alle Gäste vorhanden. Eine separate Toilette sorgt für zusätzlichen Komfort.",
      paragraph4:
        "Zur ultimativen Entspannung verfügt die Villa über eine eigene Sauna, in der du dich nach einem aktiven Tag wunderbar erholen kannst. Draußen lädt die möblierte Terrasse dazu ein, die frische Seeluft und Mahlzeiten im Freien zu genießen. Kostenloses WLAN sorgt dafür, dass du stets mit deinen Lieben verbunden bleibst.",
      paragraph5:
        "Der Ferienpark Kijkduin bietet zahlreiche Einrichtungen für Jung und Alt – von einem Hallenbad und Sportplätzen bis hin zu gemütlichen Restaurants und einem Supermarkt für den täglichen Bedarf. Der nahegelegene Strand, nur 500 Meter entfernt, ermöglicht spontane Strandspaziergänge und sonnige Tage am Meer.",
      paragraph6:
        "Erlebe selbst die perfekte Balance zwischen Komfort, Natur und Erholung in dieser wunderschönen Duinvilla im Ferienpark Kijkduin. Ein unvergesslicher Urlaub wartet auf dich!",
    },
    footer: {
      contactReserve: "Kontakt & Reservierung",
      slogan:
        "Entfliehen Sie dem Trubel und genießen Sie die wunderschönen Dünen von Den Haag.",
      tagline: "Ihr Zuhause in den Dünen",
      description1:
        "Vakantiehuis Kijkduin – Ihr ideales Reiseziel für einen erholsamen Urlaub in den wunderschönen Dünen. Gelegen in einer ruhigen Umgebung, der perfekte Ort, um die Natur, den Strand und die Stadt zu genießen. Entspannen Sie sich, erkunden Sie die Umgebung und schaffen Sie schöne Erinnerungen.",
      description2:
        "Haben Sie Fragen oder möchten Sie reservieren? Kontaktieren Sie uns gerne!",
      locationTitle: "Standort",
      address: {
        line1: "Machiel Vrijenhoeklaan 450-51",
        line2: "2555 NW Den Haag",
        country: "Niederlande",
      },
      rights: "Alle Rechte vorbehalten",
      designBy: "Design und Umsetzung von",
      nav: {
        home: "Startseite",
        reserve: "Reservieren",
        privacy: "Datenschutz",
      },
    },
  },
  it: {
    contactUs: "Contattaci",
    experienceDunes: "Vivi le dune dell'Aia",
    availability: "Disponibilità",
    perNight: "€{price} / notte",
    guests: "Ospiti",
    arrival: "Arrivo",
    departure: "Partenza",
    adults: "Adulti",
    children: "Bambini",
    babies: "Neonati",
    apply: "Applica",
    changeDay: "Giorno di cambio",
    everyDay: "Ogni giorno",
    finalCleaning: "Pulizia finale",
    stay: "Soggiorno",
    nights: "{nights} x € {price},00",
    total: "Totale",
    requestBooking: "Richiedi prenotazione",
    viewSeasonalPrices: "Visualizza prezzi stagionali",
    accomodation: "Alloggio",
    reserve: "Prenota",
    contact: "Contatto",
    phone: "Telefono",
    email: "Email",
    poolHeating: "Riscaldamento piscina",
    intermediateCleaning: "Pulizia intermedia",
    bookNowTextRoompot:
      "Le prenotazioni sono gestite tramite Roompot Paesi Bassi",
    bookNow: "Effettua una prenotazione",
    bookNowButton: "Prenota ora",
    bookNowSubtitle: "Goditi la spiaggia e le dune dell'Aia",
    emailLabel: "Email:",
    lang: {
      english: "Inglese",
      dutch: "Olandese",
      german: "Tedesco",
      italian: "Italiano",
      french: "Francese",
      spanish: "Spagnolo",
      portuguese: "Portoghese",
    },
    villaFacilities: "Servizi nella villa",
    parkFacilities: "Servizi nel parco vacanze",
    aboutVillaTitle: "La Villa delle Dune a Vakantiepark Kijkduin",
    villaPeek: "Uno sguardo all'interno della Villa delle Dune",
    features: {
      people: "1 - 7 persone",
      bedrooms: "3 camere da letto",
      bathrooms: "2 bagni",
      livingSpace: "105m² di spazio abitativo",
      detached: "Indipendente",
      garden: "Giardino privato con terrazza",
      wifi: "Wi-Fi gratuito",
      fireplace: "Caminetto",
      coffee: "Macchina del caffè",
      tv: "Televisione",
      toilet: "Bagno separato",
      sauna: "Sauna",
      beach: "Sulla spiaggia",
      supermarket: "Supermercato",
      charging: "Punto di ricarica per veicoli elettrici",
      bikes: "Noleggio biciclette e go-kart",
      kids: "Kids Club e parchi giochi",
      animation: "Programma di animazione",
      swimming: "Piscina coperta e piscina per bambini",
      padel: "Padel e mini golf",
      food: "Caffetteria e snack bar",
      wifiPark: "Wi-Fi nel parco (gratuito)",
    },
    bookingBenefits: {
      freeCancellation: "Cancellazione gratuita entro 14 giorni",
      rebookingGuarantee: "Garanzia di riprenotazione entro 28 giorni",
      flexiblePayment: "Opzioni di pagamento flessibili",
    },
    aboutVilla: {
      paragraph1:
        "Immagina di svegliarti in questa villa indipendente tra le dune, circondato dalla natura tranquilla del Vakantiepark Kijkduin all'Aia. Questa villa recentemente ristrutturata può ospitare fino a sette persone e combina comfort moderno con un'atmosfera calda e accogliente.",
      paragraph2:
        "Entrando, troverai un ampio soggiorno con una confortevole area relax e un affascinante caminetto, perfetto per serate rilassanti. L'adiacente zona pranzo è ideale per i pasti e le serate di gioco. La cucina moderna è completamente attrezzata con forno a microonde combinato, lavastoviglie e macchina del caffè, permettendoti di preparare deliziosi pasti senza sforzo.",
      paragraph3:
        "La villa dispone di tre confortevoli camere da letto. Una si trova al piano terra con due letti singoli a molle, ideale per gli ospiti che preferiscono non utilizzare le scale. Al piano superiore, ci sono altre due camere da letto: una con due letti singoli e un'altra con tre. Con due bagni distribuiti su entrambi i piani, c'è abbondanza di comfort e privacy. Un bagno separato aggiunge ulteriore comodità.",
      paragraph4:
        "Per un relax assoluto, la villa include una sauna privata, perfetta dopo una giornata di attività. All'esterno, la terrazza arredata invita a godere dell'aria fresca di mare e dei pasti all'aperto. Il Wi-Fi gratuito garantisce che tu sia sempre connesso con casa o con il tuo intrattenimento preferito.",
      paragraph5:
        "Vakantiepark Kijkduin offre una vasta gamma di servizi per tutte le età, dalla piscina coperta ai campi sportivi, ai locali accoglienti e a un supermercato. La spiaggia, a soli 500 metri di distanza, rende facile godere di passeggiate spontanee o giornate di sole in spiaggia.",
      paragraph6:
        "Sperimenta l'equilibrio perfetto tra comfort, natura e relax in questa bellissima villa tra le dune a Vakantiepark Kijkduin. Una vacanza indimenticabile ti aspetta!",
    },
    footer: {
      contactReserve: "Contatti e Prenotazioni",
      slogan: "Fuggi dalla frenesia e rilassati nelle splendide dune dell'Aia.",
      tagline: "La tua casa tra le dune",
      description1:
        "Vakantiehuis Kijkduin, la tua destinazione ideale per una vacanza rilassante tra le splendide dune. Situato in un ambiente sereno, è il luogo perfetto per godersi la natura, la spiaggia e la città. Rilassati, esplora i dintorni e crea ricordi indimenticabili.",
      description2: "Hai domande o vuoi prenotare? Non esitare a contattarci!",
      locationTitle: "Posizione",
      address: {
        line1: "Machiel Vrijenhoeklaan 450-51",
        line2: "2555 NW L'Aia",
        country: "Paesi Bassi",
      },
      rights: "Tutti i diritti riservati",
      designBy: "Design e sviluppo di",
      nav: {
        home: "Home",
        reserve: "Prenota",
        privacy: "Privacy",
      },
    },
  },
  fr: {
    contactUs: "Contactez-nous",
    experienceDunes: "Découvrez les dunes de La Haye",
    availability: "Disponibilité",
    perNight: "€{price} / nuit",
    guests: "Invités",
    arrival: "Arrivée",
    departure: "Départ",
    adults: "Adultes",
    children: "Enfants",
    babies: "Bébés",
    apply: "Appliquer",
    changeDay: "Jour de changement",
    everyDay: "Tous les jours",
    finalCleaning: "Nettoyage final",
    stay: "Séjour",
    nights: "{nights} x € {price},00",
    total: "Total",
    requestBooking: "Demander une réservation",
    viewSeasonalPrices: "Voir les prix saisonniers",
    accomodation: "Hébergement",
    reserve: "Réserver",
    contact: "Contact",
    phone: "Téléphone",
    email: "E-mail",
    poolHeating: "Chauffage de piscine",
    intermediateCleaning: "Nettoyage intermédiaire",
    bookNowTextRoompot: "Les réservations sont gérées via Roompot Pays-Bas",
    bookNow: "Faire une réservation",
    bookNowButton: "Réserver maintenant",
    bookNowSubtitle: "Profitez de la plage et des dunes de La Haye",
    emailLabel: "E-mail:",
    lang: {
      english: "Anglais",
      dutch: "Néerlandais",
      german: "Allemand",
      italian: "Italien",
      french: "Français",
      spanish: "Espagnol",
      portuguese: "Portugais",
    },
    villaFacilities: "Équipements dans la villa",
    parkFacilities: "Équipements dans le parc de vacances",
    aboutVillaTitle: "À propos de la Villa des Dunes à Vakantiepark Kijkduin",
    villaPeek: "Un aperçu de l'intérieur de la Villa des Dunes",
    features: {
      people: "1 - 7 personnes",
      bedrooms: "3 chambres",
      bathrooms: "2 salles de bain",
      livingSpace: "105m² d'espace habitable",
      detached: "Indépendante",
      garden: "Jardin privé avec terrasse",
      wifi: "Wi-Fi gratuit",
      fireplace: "Cheminée",
      coffee: "Machine à café",
      tv: "Télévision",
      toilet: "Toilette séparée",
      sauna: "Sauna",
      beach: "À la plage",
      supermarket: "Supermarché",
      charging: "Borne de recharge VE",
      bikes: "Location de vélos et karts",
      kids: "Club enfants et aires de jeux",
      animation: "Programme d'animation",
      swimming: "Piscine intérieure et pataugeoire",
      padel: "Padel et mini-golf",
      food: "Café et snack-bar",
      wifiPark: "Wi-Fi dans le parc (gratuit)",
    },
    bookingBenefits: {
      freeCancellation: "Annulation gratuite dans les 14 jours",
      rebookingGuarantee: "Garantie de réservation dans les 28 jours",
      flexiblePayment: "Options de paiement flexibles",
    },
    aboutVilla: {
      paragraph1:
        "Imaginez-vous vous réveiller dans cette villa de dunes indépendante, entourée par la nature paisible de Vakantiepark Kijkduin à La Haye. Cette villa récemment rénovée peut accueillir jusqu'à sept personnes et combine confort moderne avec une atmosphère chaleureuse et accueillante.",
      paragraph2:
        "En entrant, vous trouverez un salon spacieux avec un coin salon confortable et une charmante cheminée, parfait pour des soirées de détente. La salle à manger adjacente est idéale pour les repas et les soirées de jeux. La cuisine moderne est entièrement équipée avec un four micro-ondes combiné, un lave-vaisselle et une machine à café, vous permettant de préparer de délicieux repas sans effort.",
      paragraph3:
        "La villa dispose de trois chambres confortables. L'une est située au rez-de-chaussée avec deux lits simples à ressorts, idéale pour les invités qui préfèrent ne pas utiliser les escaliers. À l'étage, il y a deux chambres supplémentaires : une avec deux lits simples et une autre avec trois. Avec deux salles de bain réparties sur les deux étages, il y a beaucoup de confort et d'intimité. Des toilettes séparées ajoutent un confort supplémentaire.",
      paragraph4:
        "Pour une relaxation ultime, la villa comprend un sauna privé, parfait après une journée d'activités. À l'extérieur, la terrasse meublée vous invite à profiter de l'air frais de la mer et des repas en plein air. Le Wi-Fi gratuit vous assure de rester toujours connecté à votre domicile ou à vos divertissements préférés.",
      paragraph5:
        "Vakantiepark Kijkduin offre une large gamme d'équipements pour tous les âges, d'une piscine intérieure et des terrains de sport à des restaurants confortables et un supermarché. La plage, à seulement 500 mètres, rend les promenades spontanées ou les journées ensoleillées à la plage faciles à apprécier.",
      paragraph6:
        "Expérimentez l'équilibre parfait entre confort, nature et détente dans cette belle villa des dunes à Vakantiepark Kijkduin. Des vacances inoubliables vous attendent !",
    },
    footer: {
      contactReserve: "Contact & Réservations",
      slogan:
        "Évadez-vous de l'agitation et détendez-vous dans les magnifiques dunes de La Haye.",
      tagline: "Votre maison dans les dunes",
      description1:
        "Vakantiehuis Kijkduin, votre destination idéale pour des vacances reposantes dans les magnifiques dunes. Située dans un environnement paisible, c’est l’endroit parfait pour profiter de la nature, de la plage et de la ville. Détendez-vous, explorez les environs et créez de merveilleux souvenirs.",
      description2:
        "Vous avez des questions ou souhaitez faire une réservation ? N’hésitez pas à nous contacter !",
      locationTitle: "Localisation",
      address: {
        line1: "Machiel Vrijenhoeklaan 450-51",
        line2: "2555 NW La Haye",
        country: "Pays-Bas",
      },
      rights: "Tous droits réservés",
      designBy: "Conception et développement par",
      nav: {
        home: "Accueil",
        reserve: "Réserver",
        privacy: "Confidentialité",
      },
    },
  },
  es: {
    contactUs: "Contáctanos",
    experienceDunes: "Disfruta de las dunas de La Haya",
    availability: "Disponibilidad",
    perNight: "€{price} / noche",
    guests: "Huéspedes",
    arrival: "Llegada",
    departure: "Salida",
    adults: "Adultos",
    children: "Niños",
    babies: "Bebés",
    apply: "Aplicar",
    changeDay: "Día de cambio",
    everyDay: "Todos los días",
    finalCleaning: "Limpieza final",
    stay: "Estancia",
    nights: "{nights} x € {price},00",
    total: "Total",
    requestBooking: "Solicitar reserva",
    viewSeasonalPrices: "Ver precios por temporada",
    accomodation: "Alojamiento",
    reserve: "Reservar",
    contact: "Contacto",
    phone: "Teléfono",
    email: "Correo electrónico",
    poolHeating: "Calefacción de piscina",
    intermediateCleaning: "Limpieza intermedia",
    bookNowTextRoompot:
      "Las reservas se gestionan a través de Roompot Países Bajos",
    bookNow: "Hacer una reserva",
    bookNowButton: "Reservar ahora",
    bookNowSubtitle: "Disfruta de la playa y las dunas de La Haya",
    emailLabel: "Correo electrónico:",
    lang: {
      english: "Inglés",
      dutch: "Holandés",
      german: "Alemán",
      italian: "Italiano",
      french: "Francés",
      spanish: "Español",
      portuguese: "Portugués",
    },
    villaFacilities: "Instalaciones en la villa",
    parkFacilities: "Instalaciones en el parque vacacional",
    aboutVillaTitle: "Sobre la Villa de las Dunas en Vakantiepark Kijkduin",
    villaPeek: "Un vistazo al interior de la Villa de las Dunas",
    features: {
      people: "1 - 7 personas",
      bedrooms: "3 dormitorios",
      bathrooms: "2 baños",
      livingSpace: "105m² de espacio habitable",
      detached: "Independiente",
      garden: "Jardín privado con terraza",
      wifi: "Wifi gratuito",
      fireplace: "Chimenea",
      coffee: "Cafetera",
      tv: "Televisión",
      toilet: "Aseo separado",
      sauna: "Sauna",
      beach: "En la playa",
      supermarket: "Supermercado",
      charging: "Punto de carga para vehículos eléctricos",
      bikes: "Alquiler de bicicletas y karts",
      kids: "Club infantil y áreas de juego",
      animation: "Programa de animación",
      swimming: "Piscina cubierta y piscina infantil",
      padel: "Pádel y minigolf",
      food: "Café y bar de aperitivos",
      wifiPark: "Wifi en el parque (gratuito)",
    },
    bookingBenefits: {
      freeCancellation: "Cancelación gratuita dentro de los 14 días",
      rebookingGuarantee: "Garantía de cambio de reserva dentro de los 28 días",
      flexiblePayment: "Opciones de pago flexibles",
    },
    aboutVilla: {
      paragraph1:
        "Imagina despertar en esta villa independiente en las dunas, rodeado por la tranquila naturaleza de Vakantiepark Kijkduin en La Haya. Esta villa recientemente renovada tiene capacidad para hasta siete personas y combina el confort moderno con un ambiente cálido y acogedor.",
      paragraph2:
        "Al entrar, encontrarás un amplio salón con una acogedora zona de estar y una encantadora chimenea, perfecto para veladas relajantes. El comedor contiguo es ideal para comidas y noches de juegos. La cocina moderna está completamente equipada con un horno microondas combinado, lavavajillas y cafetera, lo que te permite preparar deliciosas comidas sin esfuerzo.",
      paragraph3:
        "La villa cuenta con tres cómodas habitaciones. Una está situada en la planta baja con dos camas individuales tipo box spring, ideal para huéspedes que prefieren no usar escaleras. En el piso superior, hay dos habitaciones más: una con dos camas individuales y otra con tres. Con dos baños distribuidos en ambas plantas, hay mucha comodidad y privacidad. Un aseo separado añade mayor conveniencia.",
      paragraph4:
        "Para una relajación total, la villa incluye una sauna privada, perfecta después de un día de actividades. En el exterior, la terraza amueblada te invita a disfrutar del aire fresco del mar y de las comidas al aire libre. El wifi gratuito asegura que siempre estés conectado con tu hogar o tu entretenimiento favorito.",
      paragraph5:
        "Vakantiepark Kijkduin ofrece una amplia gama de servicios para todas las edades, desde una piscina cubierta y campos deportivos hasta acogedores restaurantes y un supermercado. La playa, a solo 500 metros de distancia, facilita paseos espontáneos o días soleados en la playa.",
      paragraph6:
        "Experimenta el equilibrio perfecto entre comodidad, naturaleza y relajación en esta hermosa villa de las dunas en Vakantiepark Kijkduin. ¡Te espera una vacación inolvidable!",
    },
    footer: {
      contactReserve: "Contacto y Reservas",
      slogan: "Escapa del ajetreo y relájate en las hermosas dunas de La Haya.",
      tagline: "Tu hogar en las dunas",
      description1:
        "Vakantiehuis Kijkduin, tu destino ideal para unas vacaciones relajantes en las hermosas dunas. Ubicado en un entorno sereno, es el lugar perfecto para disfrutar de la naturaleza, la playa y la ciudad. Relájate, explora los alrededores y crea recuerdos inolvidables.",
      description2:
        "¿Tienes preguntas o deseas hacer una reserva? ¡No dudes en contactarnos!",
      locationTitle: "Ubicación",
      address: {
        line1: "Machiel Vrijenhoeklaan 450-51",
        line2: "2555 NW La Haya",
        country: "Países Bajos",
      },
      rights: "Todos los derechos reservados",
      designBy: "Diseño y desarrollo por",
      nav: {
        home: "Inicio",
        reserve: "Reservar",
        privacy: "Privacidad",
      },
    },
  },
  pt: {
    contactUs: "Entre em contato",
    experienceDunes: "Experimente as dunas de Haia",
    availability: "Disponibilidade",
    perNight: "€{price} / noite",
    guests: "Hóspedes",
    arrival: "Chegada",
    departure: "Partida",
    adults: "Adultos",
    children: "Crianças",
    babies: "Bebês",
    apply: "Aplicar",
    changeDay: "Dia de troca",
    everyDay: "Todos os dias",
    finalCleaning: "Limpeza final",
    stay: "Estadia",
    nights: "{nights} x € {price},00",
    total: "Total",
    requestBooking: "Solicitar reserva",
    viewSeasonalPrices: "Ver preços sazonais",
    accomodation: "Acomodação",
    reserve: "Reservar",
    contact: "Contato",
    phone: "Telefone",
    email: "E-mail",
    poolHeating: "Aquecimento da piscina",
    intermediateCleaning: "Limpeza intermediária",
    bookNowTextRoompot: "As reservas são gerenciadas via Roompot Holanda",
    bookNow: "Faça uma reserva",
    bookNowButton: "Reserve agora",
    bookNowSubtitle: "Aproveite a praia e as dunas de Haia",
    emailLabel: "E-mail:",
    lang: {
      english: "Inglês",
      dutch: "Holandês",
      german: "Alemão",
      italian: "Italiano",
      french: "Francês",
      spanish: "Espanhol",
      portuguese: "Português",
    },
    villaFacilities: "Facilidades na villa",
    parkFacilities: "Facilidades no parque de férias",
    aboutVillaTitle: "Sobre a Villa das Dunas no Vakantiepark Kijkduin",
    villaPeek: "Uma espiada dentro da Villa das Dunas",
    features: {
      people: "1 - 7 pessoas",
      bedrooms: "3 quartos",
      bathrooms: "2 banheiros",
      livingSpace: "105m² de espaço habitável",
      detached: "Independente",
      garden: "Jardim privativo com terraço",
      wifi: "Wi-Fi gratuito",
      fireplace: "Lareira",
      coffee: "Máquina de café",
      tv: "Televisão",
      toilet: "Banheiro separado",
      sauna: "Sauna",
      beach: "Na praia",
      supermarket: "Supermercado",
      charging: "Ponto de carregamento para veículos elétricos",
      bikes: "Aluguel de bicicletas e karts",
      kids: "Clube infantil e parques infantis",
      animation: "Programa de animação",
      swimming: "Piscina coberta e piscina infantil",
      padel: "Padel e minigolfe",
      food: "Café e lanchonete",
      wifiPark: "Wi-Fi no parque (gratuito)",
    },
    bookingBenefits: {
      freeCancellation: "Cancelamento gratuito dentro de 14 dias",
      rebookingGuarantee: "Garantia de remarcação dentro de 28 dias",
      flexiblePayment: "Opções de pagamento flexíveis",
    },
    aboutVilla: {
      paragraph1:
        "Imagine acordar nesta villa independente nas dunas, cercado pela natureza tranquila do Vakantiepark Kijkduin em Haia. Esta villa recentemente renovada acomoda até sete pessoas e combina conforto moderno com uma atmosfera acolhedora e familiar.",
      paragraph2:
        "Ao entrar, você encontrará uma espaçosa sala de estar com uma área de assentos confortável e uma charmosa lareira, perfeita para noites relaxantes. A área de jantar adjacente é ideal para refeições e noites de jogos. A cozinha moderna é totalmente equipada com forno-micro-ondas combinado, máquina de lavar louça e cafeteira, permitindo que você prepare refeições deliciosas sem esforço.",
      paragraph3:
        "A villa possui três quartos confortáveis. Um está localizado no térreo com duas camas de solteiro box spring, ideal para hóspedes que preferem não usar escadas. No andar superior, há mais dois quartos: um com duas camas de solteiro e outro com três. Com dois banheiros distribuídos pelos dois andares, há bastante conforto e privacidade. Um banheiro separado adiciona mais conveniência.",
      paragraph4:
        "Para o relaxamento máximo, a villa inclui uma sauna privativa, perfeita após um dia de atividades. No exterior, o terraço mobiliado convida você a desfrutar do ar fresco do mar e refeições ao ar livre. Wi-Fi gratuito garante que você esteja sempre conectado com sua casa ou seu entretenimento favorito.",
      paragraph5:
        "O Vakantiepark Kijkduin oferece uma ampla gama de comodidades para todas as idades, desde uma piscina coberta e campos esportivos até restaurantes aconchegantes e um supermercado. A praia, a apenas 500 metros de distância, torna passeios espontâneos ou dias ensolarados na praia fáceis de aproveitar.",
      paragraph6:
        "Experimente o equilíbrio perfeito entre conforto, natureza e relaxamento nesta bela villa das dunas no Vakantiepark Kijkduin. Umas férias inesquecíveis estão à sua espera!",
    },
    footer: {
      contactReserve: "Contato e Reservas",
      slogan: "Escape da agitação e relaxe nas belas dunas de Haia.",
      tagline: "Sua casa nas dunas",
      description1:
        "Vakantiehuis Kijkduin, o seu destino ideal para umas férias relaxantes nas belas dunas. Localizado num ambiente sereno, é o lugar perfeito para desfrutar da natureza, da praia e da cidade. Relaxe, explore os arredores e crie memórias incríveis.",
      description2:
        "Tem alguma dúvida ou deseja fazer uma reserva? Não hesite em entrar em contato!",
      locationTitle: "Localização",
      address: {
        line1: "Machiel Vrijenhoeklaan 450-51",
        line2: "2555 NW Haia",
        country: "Países Baixos",
      },
      rights: "Todos os direitos reservados",
      designBy: "Design e desenvolvimento por",
      nav: {
        home: "Início",
        reserve: "Reservar",
        privacy: "Privacidade",
      },
    },
  },
};

const getBrowserLanguage = () => {
  const language = navigator.language || navigator.userLanguage;
  return language.split("-")[0];
};

const i18n = createI18n({
  locale: getBrowserLanguage(),
  fallbackLocale: "nl",
  messages,
});

export default i18n;
